module.exports = __webpack_public_path__ + "static/media/trash.cbc8add9.svg";